import React from 'react';
import { flowType } from '@utility/userInfo';
import { LABEL, CUSTOM_MESSAGES } from '../../veriables';
import PaidStamp from '@assets/images/payment/paid.png';
import {ReactComponent as Previous} from '@assets/images/previous.svg';
import next from '@assets/images/next.svg';
import cn from 'classnames';
import styles from './stagePayment.module.scss';

const StagePayment = (props) => {

  // Props Destructuring
  const {
    tableData,
    currencySymbol,
    stageData,
    seatItems,
    stageInfo,
    onClickPaymentHandler,
    countryCode,
    allMenuItems,
    selectedStageIndex,
    sortedSeatItemHashTable,
    prevCheck,
    nextCheck,
    ShowLandscapeMode,
    seat,
    serverAppTheme
  } = props

  // Methods

  const renderModifier = (modifiersObj, nest) => (
    (modifiersObj || []).map((modifier) => (
      <>
      <div key={modifier.modifierId} className="fs-14 fw-500 row mx-0 col-12 p-0">
    {modifier.quantity >= 1 ? <div className={cn('col-1 text-left p-0 pl-0')}> <div className={cn('va-tt fs-16')}>{modifier.quantity}</div></div> : <div className='p-0 text-left col-2 px-1'></div>}
            <div className={cn( 'col-6 p-0 text-left fs-16', nest && 'pl-3' )}>{modifier.modifierName}</div>
            <div className='px-0 h-8 d-flex align-items-center col-2'></div>
            {modifier.price ? (<div className={cn( "col-3 text-right fs-16 px-0")} style={{paddingRight:'0.7rem'}}>{LABEL().CURRENCY_SYMBOL}{modifier.price.toFixed(2)}</div>) :<div className={cn( "col-3 text-right fs-16 px-0")} style={{paddingRight:'0.7rem'}}> $0.00 </div>}
            {(modifier.note || modifier.comment) && <div className="pl-2">{modifier.note || modifier.comment}</div>}
          </div>
          <div>
            {modifier.modifiers && modifier.modifiers.length > 0 && (
              renderModifier(modifier.modifiers, true)
            )}
          </div>
</>
    ))
  );

  const excludeItemFromReceiptScreen = (item) => {
    let excludeProduct = false; 
    allMenuItems?.forEach((insideItems)=> {
      if(insideItems.id === item.menuItemId && insideItems?.excludeFromReceipt) {
        excludeProduct =  true;
      }
    })
    return excludeProduct;   
  }

  // HTML CSS CODE

  return (
    <>
      <div className={cn(ShowLandscapeMode ? 'col-6' : 'col-12 h-96 p-0')} style={{flexFlow:'column', display:'flex'}}>
      {seatItems.length > 0 ? (
        
        <div className={cn("h-58 fs_18  overflowY position-relative")} style={{flex:'1 1 auto', marginBottom:'2%'}}>
         {seatItems.map((item) => {
           const excludeFromReceipt = excludeItemFromReceiptScreen(item);
           return (
             <>
              {!excludeFromReceipt && <div key={item.menuItemId} className={cn('col-12 row mx-0 mt-1 py-2 w-100 align-content-center fs-20 fw-500',styles.menuItems)} style={{background:serverAppTheme?.tip_tile}}>
              <div className="col-1 p-0 text-left fs-20">
                {' '}
                <span>
                  {item?.seats? 
                      <div className='text-left'>{item?.seats?.length > 1 ? '1/' + (item?.seats?.length) : item.quantity}</div>
                    :
                      <div className='text-left'>{item?.seatIds?.length > 1 ? '1/' + (item?.seatIds?.length) : item.quantity}</div> 
                    }
                </span>
              </div>
               <div className="col-7 p-0 text-left">
                 <div className="row mx-0">
                   <span className={cn('p-0 fw-500', styles.divForPaymentCopy)}>
                     {item.menuItemName}
                   </span>
                 </div>
               </div>
                {item?.seats? <div className='col-1 px-0 h-8 d-flex justify-content-center align-items-center'>
                      <div className=' fs-18 fw-500 w-80 h-100 rounded d-flex justify-content-center align-items-center' style={{color: serverAppTheme?.seat_box_text, background:serverAppTheme?.seat_bg}}>{item?.seats?.length > 1 ? item?.seats[0]?.tableOrder ? 'T' : 'S' : seat?.seats?.filter((i) => i?.id === item?.seats[0]?.seatId)[0]?.number}</div>
                    </div> :
                      <div className='col-1 px-0 h-8 d-flex justify-content-center align-items-center'>
                        <div className=' fs-18 fw-500 w-80 h-100 rounded d-flex justify-content-center align-items-center' style={{color: serverAppTheme?.seat_box_text, background:serverAppTheme?.seat_bg}}>{item?.seatIds?.length > 1 ? '1/' + (item?.seatIds?.length) : seat?.seats?.filter((i) => i?.id === item?.seatIds[0])[0]?.number}</div>
                      </div>
                    }
               <div className="col-3 p-0 fw-600 text-right fs-20">
                 {currencySymbol}
                 {(item.price).toFixed(2)}
               </div>
               <div className="col-12 p-0">
                 {item.modifiers && renderModifier(item.modifiers)}
                 <div className="text-left pl-2 fs-18">
                   {`${item.note ? `- ${item.note}` : ''}`}
                 </div>
               </div>
             </div>}
             </>
           );
         })}
       </div>  
     ) : <div className={'h-58 d-flex fs-600 justify-content-center align-items-center fs_18 fw-400'} style={{color: serverAppTheme?.noRecord, marginBottom:'2%'}}>{CUSTOM_MESSAGES().NO_ITEM_FOUND}</div>}
     <div className={cn('col-12 p-2 w-100 overflowY mx-0 rounded',styles.amoutSplit, ShowLandscapeMode ? "h-40" : 'h-15')} style={{background:serverAppTheme?.selector_control_color, color:serverAppTheme?.primary_text}}>
       {countryCode === '44' ? (
         <div className="row m-0 pb-2 fw-normal fs_20">
           <div className="col-6 p-0 text-left">{LABEL().TOTAL}</div>
           <div className="col-6 p-0 text-right">
             {currencySymbol}{(stageInfo.totalAmount || stageInfo.totalAmount === 0) && stageInfo.totalAmount.toFixed(2)}
           </div>
         </div>
       ) : (
         <div className="row mx-0 pb-2 fw-normal fs_20">
           <div className={cn('col-6 p-0 text-left')}>{LABEL().SUB_TOTAL}</div>
           <div className={cn('p-0 text-right col-6')}>
             {currencySymbol}{(stageInfo.subTotalAmount || stageInfo.subTotalAmount === 0) && stageInfo.subTotalAmount.toFixed(2)}
           </div>
         </div>
       )}
       <div className="row mx-0 pb-2 fw-normal fs_20">
         <div className={cn('col-6 p-0 text-left')}>{countryCode === '44' ? LABEL().VAT : LABEL().TAX}</div>
         <div className={cn('p-0 text-right col-6')} >
           {currencySymbol}{(stageInfo.taxAmount || stageInfo.taxAmount === 0) && stageInfo.taxAmount.toFixed(2)}
         </div>
       </div>
       {(stageInfo.serviceChargeAmount > 0) && <div className="row mx-0 pb-2 fw-normal fs_20">
         <div className={cn('col-6 p-0 text-left', styles.divForPaymentCopy)}>{LABEL().SERVICE_CHARGE}</div>
         <div className={cn('p-0 text-right col-6', styles.divForPaymentCopy)}>
           {currencySymbol}{stageInfo?.serviceChargeAmount.toFixed(2)}
         </div>
       </div>}
       {(stageInfo.discountAmount >= 0) && <div className="row mx-0 pb-2 fw-normal fs_20">
         <div className={cn('col-6 p-0 text-left')}>{LABEL().DISCOUNT_AMOUNT}</div>
         <div className={cn('p-0 text-right col-6')}>
           {currencySymbol}{stageInfo?.discountAmount.toFixed(2)}
         </div>
       </div>}
       {countryCode !== '44' && (
         <div className="row m-0 fs_20 fw-normal">
           <div className={cn('col-6 p-0 text-left')}>{LABEL().PAYEMENT_TOTAL_DUE}</div>
           <div className={cn('col-6 p-0 text-right')}>
             {currencySymbol}{(stageInfo.totalAmount || stageInfo.totalAmount === 0) && stageInfo.totalAmount.toFixed(2)}
           </div>
         </div>
       )}
     </div>
     { !ShowLandscapeMode && <div className='col-12 px-0 h-25' style={{flex: '0 1 160px'}}>
      <div className="col-12 px-0 row justify-content-center mx-0 pt-2 align-items-center">
        <button type="button" className={cn('col rounded btn-ripple text-center fs_24 fw-600 p-0')} style={{lineHeight:"normal", backgroundColor: serverAppTheme?.OFF_Premise_Btn, border: serverAppTheme?.cancleBtn_Border, color: serverAppTheme?.cancleBtn_font, height:'7.5vh'}} onClick ={() => prevCheck()}> <Previous fill={serverAppTheme?.iconcolor} alt='' className='pr-2' /><span>Previous</span></button>
        <div className={cn('col-2 fs_24  fw-600 px-1 text-center ', styles.divForPaymentCopy)}> {(selectedStageIndex + 1) + '/' + tableData?.paymentStages.length}</div>
        <button type= "button" className={cn('col rounded btn-ripple text-center text-white fs_24 fw-600 p-0')} style={{lineHeight:"normal", border: "none", backgroundColor: serverAppTheme?.secondaryBtn, height:'7.5vh'}} onClick={() => nextCheck()}> <span>Next</span> <img src={next} alt='' className='px-1' /></button>
      </div>
      {(stageData.status === 0) && <button
        type="button"
        onClick={() => { onClickPaymentHandler(stageInfo); }}
        disabled={stageData.status !== 0 || (Number(stageInfo.unpaidAmount) <= 0)}
        className={cn(styles.disabledBtn, 'text-center col-12 px-0 text-white btn-ripple h-10 d-flex justify-content-center align-items-center  w-100 border-0 fs_24 fw-600', stageData.status !== 0 || (Number(stageInfo.unpaidAmount) <= 0) ? 'disabledButton' : '', ['kiosk'].includes(flowType()) ? 'btn100' : 'btn50')} 
        style={{backgroundColor: serverAppTheme?.secondaryBtn, '--disabled-primarybtn': serverAppTheme?.secondary_btn_disable, '--disabled-btntext': serverAppTheme?.secondary_btn_disable_text, fontFamily: 'Poppins', height:'7vh', borderRadius:'4px' }}
      >
        {LABEL().PAY} {LABEL().CURRENCY_SYMBOL}{stageInfo.totalAmount.toFixed(2)}
      </button>}
      {stageData.status === 2 && (
      <div className={cn('col-12 row justify-content-center position-absolute fs_24 fw-800', styles.PaidStamp)}>
          {<img src={PaidStamp} alt="" height="100px" />}
      </div>
      )} 
     </div> }
    </div>
    
    { ShowLandscapeMode && <div className='col-6 h-100'>
      <div className='col-12' style={{marginTop : '25vh'}}>
      <div className="col-12 px-1 py-2 row justify-content-center mx-0 pt-4 h-25 align-items-center">
        <button type="button" className={cn('col btn p-1 h-100 btn-ripple text-white text-center fw-500', selectedStageIndex === 0 ? 'od-btn-secondary' : 'od-btn-primary')} style={{lineHeight:"normal", border: "none",fontSize: "1.5rem", backgroundColor:'#262626'}} onClick ={() => prevCheck()}>Previous Check</button>
        <div className={cn('col-1 mx-2 fs-28 px-1 text-center', styles.divForPaymentCopy)}> {(selectedStageIndex + 1) + '/' + tableData?.paymentStages.length}</div>
        <button type= "button" className={cn('col btn p-1 h-100 btn-ripple text-center fw-500', (selectedStageIndex < (sortedSeatItemHashTable.length-1)) ? 'od-btn-primary' : 'od-btn-secondary' )} style={{lineHeight:"normal", border: "none", fontSize: "1.5rem", backgroundColor:'#0060FF'}} onClick={() => nextCheck()}>Next Check </button>
      </div>
      {(stageData.status === 0) && <button
        type="button"
        onClick={() => { onClickPaymentHandler(stageInfo); }}
        disabled={stageData.status !== 0 || (Number(stageInfo.unpaidAmount) <= 0)}
        className={cn('btn text-center btn-primary btn-ripple h-10 d-flex justify-content-center align-items-center background-primary od-text-secondary text-secondary py-1 w-100 border-0', styles.payButton, stageData.status !== 0 || (Number(stageInfo.unpaidAmount) <= 0) ? 'disabledButton' : 'od-btn-primary', ['kiosk'].includes(flowType()) ? 'btn100' : 'btn50', 'mt-2')}
      >
        {LABEL().PAY_NOW}({LABEL().CURRENCY_SYMBOL}{stageInfo.totalAmount.toFixed(2)})
      </button>}
      {stageData.status === 2 && (
          <div className={cn('col-12 row justify-content-center position-absolute text-primary fs_24 fw-800', styles.PaidStamp)}>
             {<img src={PaidStamp} alt="" height="100px" />}
          </div>
      )} 
      </div>
     </div> }
    </>
  );
};

export default StagePayment;
